var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSparks = function SvgSparks(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_596)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 5C12.9009 5 13.2258 5.32495 13.2258 5.72581C13.2258 8.0378 13.7217 9.4974 14.6242 10.394C15.5277 11.2916 16.9886 11.7742 19.2742 11.7742C19.675 11.7742 20 12.0991 20 12.5C20 12.9009 19.675 13.2258 19.2742 13.2258C16.9934 13.2258 15.5311 13.7206 14.6259 14.6259C13.7206 15.5311 13.2258 16.9934 13.2258 19.2742C13.2258 19.675 12.9009 20 12.5 20C12.0991 20 11.7742 19.675 11.7742 19.2742C11.7742 16.9946 11.2764 15.532 10.3692 14.6263C9.46172 13.7203 7.99881 13.2258 5.72581 13.2258C5.32495 13.2258 5 12.9009 5 12.5C5 12.0991 5.32495 11.7742 5.72581 11.7742C8.00365 11.7742 9.46519 11.2919 10.3708 10.3936C11.2753 9.49653 11.7742 8.03659 11.7742 5.72581C11.7742 5.32495 12.0991 5 12.5 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 0C4.85504 0 5.14286 0.287817 5.14286 0.642857C5.14286 1.93311 5.42054 2.69019 5.8713 3.13801C6.32292 3.58668 7.08113 3.85714 8.35714 3.85714C8.71218 3.85714 9 4.14496 9 4.5C9 4.85504 8.71218 5.14286 8.35714 5.14286C7.08542 5.14286 6.32599 5.41959 5.87279 5.87279C5.41959 6.32599 5.14286 7.08542 5.14286 8.35714C5.14286 8.71218 4.85504 9 4.5 9C4.14496 9 3.85714 8.71218 3.85714 8.35714C3.85714 7.08648 3.57885 6.32676 3.12451 5.87316C2.66996 5.41935 1.90996 5.14286 0.642857 5.14286C0.287817 5.14286 0 4.85504 0 4.5C0 4.14496 0.287817 3.85714 0.642857 3.85714C1.91424 3.85714 2.67304 3.58691 3.126 3.13764C3.5779 2.68942 3.85714 1.93205 3.85714 0.642857C3.85714 0.287817 4.14496 0 4.5 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSparks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sparks.a58828ad18685b001e42e5656e2a54e3.svg";